import {
  BarChart3,
  BookOpen,
  Calendar,
  FileText,
  GraduationCap,
  HeartPulse,
  MessageSquare,
  Wallet,
} from "lucide-react";
import { FEATURES } from "../../data/mock";

const iconMap = {
  GraduationCap,
  FileText,
  Wallet,
  BookOpen,
  HeartPulse,
  Calendar,
  MessageSquare,
  BarChart3,
};

const Features = () => {
  return (
    <section
      id="features"
      aria-labelledby="features-heading"
      aria-describedby="features-description"
      className="py-24 bg-[var(--bg-section)] transition-theme"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--accent-text)] text-sm font-medium mb-4">
            Features
          </span>
          <h2
            id="features-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-6 leading-tight"
          >
            Everything You Need to Run a Modern School
          </h2>
          <p
            id="features-description"
            className="text-lg text-[var(--text-body)] opacity-90"
          >
            From attendance to analytics, SEFIL 360 provides comprehensive tools
            to streamline every aspect of school administration.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-6 rounded-2xl bg-[var(--bg-card)] border border-[var(--border-light)] card-hover hover:border-[var(--accent-primary)]/30 hover:shadow-lg transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[var(--accent-wash)] flex items-center justify-center mb-4 group-hover:bg-gradient-to-br group-hover:from-[var(--accent-primary)] group-hover:to-[var(--accent-strong)] transition-all duration-300">
                  <IconComponent className="w-6 h-6 text-[var(--accent-text)] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-[var(--text-body)] leading-relaxed opacity-85">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
